import React, { Component } from "react";

import Configs from "Configuration";

import FhtMain from "../FhtMain";

import ChangePasswordDialog from 'FhtMainComponents/ChangePasswordDialog';
import UserProfileDialog from 'FhtMainComponents/UserProfileDialog';

import {
  Box,
  Button,
  Paper,
  Typography,
} from "@material-ui/core";

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

class LinkmeUserProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Dialogs
      showChangePasswordDialog: false,
      showMyProfileDialog: false,
      // Snackbar
      openSnackbar: false,
      snackbarMessage: "No message",
      snackbarVariant: Configs.snackbarVariants.info,
    };
  }

  signOut = () => {
    console.log("Signing out");
    localStorage.removeItem(Configs.userTokenInformation.userToken);
    FhtMain.GlobalContext = {
      userClaims: null,
      userRole: null,
      userName: null,
      userToken: null,
      viewableCohortIds: null,
      cohortDiseaseId: null
    };

    let menuOptions = [];
    this.setState({
      OpenProfileContextMenuAnchor: null,
      userIsLoggedIn: false,
      navbarMenu: menuOptions
    });

    window.history.pushState("", "", "/");
    window.history.go();
  };

  globalFunctionDisplaySnackbarMessage = (msg, variant) => {
    this.setState({ snackbarMessage: msg, snackbarVariant: variant, openSnackbar: true });
  };

  callbackForAllDialogsClose() {
    this.setState({
      showChangePasswordDialog: false,
      showMyProfileDialog: false,
    });
  }

  render() {
    return (
      <>
        {this.renderSnackbar()}
        {this.renderDialogs()}
        <Box>
          <Typography variant="h3" gutterBottom>My Account</Typography>
          <Paper>
            <Box sx={{ padding: 12 }}>
              <Typography variant="h6" gutterBottom>Account Management</Typography>
              <Box sx={{ paddingBottom: 12 }}>
                <Button
                  color="default"
                  variant="outlined"
                  onClick={() => this.setState({ showMyProfileDialog: true })}
                >
                  Manage My Account
                </Button>
              </Box>
              <Box sx={{ paddingBottom: 12 }}>
                <Button
                  color="default"
                  variant="outlined"
                  onClick={() => this.setState({ showChangePasswordDialog: true })}
                >
                  Change Password
                </Button>
              </Box>
              <Box sx={{ paddingBottom: 12 }}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => this.signOut()}
                >
                  Sign Out
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      </>
    );
  }

  renderDialogs() {
    return (
      <>
        {this.state.showChangePasswordDialog && (
          <ChangePasswordDialog
            GlobalFunctionDisplaySnackbarMessage={() => this.globalFunctionDisplaySnackbarMessage()}
            CallbackForAllDialogsClose={() => this.callbackForAllDialogsClose()}
          />
        )}
        {this.state.showMyProfileDialog && (
          <UserProfileDialog
            GlobalFunctionDisplaySnackbarMessage={() => this.globalFunctionDisplaySnackbarMessage()}
            CallbackForAllDialogsClose={() => this.callbackForAllDialogsClose()}
          />
        )}
      </>
    );
  }

  renderSnackbar() {
    return (
      <>
        {this.state.openSnackbar && this.state.snackbarMessage && (
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={this.state.openSnackbar}
            autoHideDuration={4000}
            onClose={() => this.setState({ openSnackbar: false })}
          >
            <SnackbarContentWrapper
              onClose={() => this.setState({ openSnackbar: false })}
              variant={this.state.snackbarVariant}
              message={this.state.snackbarMessage}
            />
          </Snackbar>
        )}
      </>
    );
  }
}

export default LinkmeUserProfile;
